import { render, staticRenderFns } from "./SimForestScene.vue?vue&type=template&id=47b155bd&scoped=true"
import script from "./SimForestScene.vue?vue&type=script&lang=js"
export * from "./SimForestScene.vue?vue&type=script&lang=js"
import style0 from "./SimForestScene.vue?vue&type=style&index=0&id=47b155bd&prod&lang=scss"
import style1 from "./SimForestScene.vue?vue&type=style&index=1&id=47b155bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b155bd",
  null
  
)

export default component.exports